module.exports = __webpack_public_path__ + "img/tcc.6672d957.png";